import type { WireMaterialInputs } from "./types";

export const materialDensityPresets = [
  { key: "steel", density: 7.85 },
  { key: "stainless", density: 7.9 },
  { key: "almg5", density: 2.66 },
  { key: "alsi5", density: 2.68 },
  { key: "inconel625", density: 8.44 },
  { key: "cusi3", density: 8.3 }
] as const;

export const defaultWireMaterialInputs: WireMaterialInputs = {
  spoolWeight: 15,
  wireDiameter: 1.2,
  density: 7.85,
  wireFeed: 11.7,
  weldingTime: 85.7
};
